import { NavigationWrapper } from '../../navigation-data';
import { ShiveRoutes } from '../../segments/route-segments';
import { UrlSegmentDelimiter } from '../../../constants-repository/app-style.constants';
import { PageKey } from '../../page-keys';

export const Reports: NavigationWrapper = {
  title: 'Berichte',
  route: ShiveRoutes.Reports,
};

export const ReportsTimetableAggregated: NavigationWrapper = {
  title: 'Leistungsübersicht',
  route: ShiveRoutes.ReportsTimeTableAggregated,
};

export const ReportsTimetableMonthly: NavigationWrapper = {
  title: 'Leistungsübersicht',
  route:
    ShiveRoutes.ReportsTimeTableAggregated +
    UrlSegmentDelimiter +
    ShiveRoutes.ReportsTimetableMonthly +
    UrlSegmentDelimiter +
    ShiveRoutes.AnyId,
  previousPage: PageKey.ReportsPageKeys.ReportsTimetableAggregated,
};

export const ReportsTimetableTimeEntries: NavigationWrapper = {
  title: 'Zeiteinträge',
  route:
    ShiveRoutes.ReportsTimeTableAggregated +
    UrlSegmentDelimiter +
    ShiveRoutes.ReportsTimetableTimeEntries +
    UrlSegmentDelimiter +
    ShiveRoutes.AnyId,
  previousPage: PageKey.ReportsPageKeys.ReportsTimetableAggregated,
};
